import type { AsyncData } from "#app";
import type { IModelResponse } from "~/services/base/dto/base.dto";
import type { IModelCheckQuotaResponse } from "./dto/quota.dto";

export class QuotaRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService
  }

  async checkQuota(params: any): Promise<AsyncData<IModelResponse<IModelCheckQuotaResponse>, any>> {
    const dataResult = await this.api(`${this.llmService}/v1/quota-association/check-quota-warning`, this.configService, {
      params,
    });
    return dataResult;
  }
}